import Link from "next/link";
import StarIcon from "@/public/assets/icons/Star.svg";

interface TryToolButtonProps {
  buttonText: string | undefined;
}

const TryToolButton = ({ buttonText }: TryToolButtonProps) => {
  return (
    <Link
      href="/sign-in"
      className="rounded-full bg-linear-to-r from-[#85A5EC] to-[#C16A80] p-1"
    >
      <button className="flex items-center justify-center gap-3 rounded-full bg-black px-6 py-3 sm:gap-5 sm:px-[30px] sm:py-4">
        <StarIcon className="size-5 sm:size-7" />
        <span className="text-center text-sm font-medium text-white sm:text-base">
          {buttonText}
        </span>
      </button>
    </Link>
  );
};

export default TryToolButton;
